import { Icon } from '@smartgift/frontend-toolkit';
import React from 'react';

import * as S from './style';

function LinkBox({ onCopy, link, active }) {
  return (
    <S.LinkBox active={active} onClick={onCopy}>
      <S.LinkBoxText>{link}</S.LinkBoxText>

      {onCopy && (
        <S.LinkBoxIconButton
          variant="link"
          color="neutral"
          onClick={e => {
            e.stopPropagation();
            if (onCopy) onCopy();
          }}
        >
          <Icon name="copy-paste" />
        </S.LinkBoxIconButton>
      )}
    </S.LinkBox>
  );
}

LinkBox.S = S;

export { LinkBox };
